const ChevronRightIcon = ({ color = '#4079F5', width = 6, height = 10 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 6 10"
    fill="none"
  >
    <path
      d="M3.72973 5L0 8.83333L1.13514 10L6 5L1.13514 0L0 1.16667L3.72973 5Z"
      fill={color}
    />
  </svg>
)

export default ChevronRightIcon
